<template>
  <div class="p-3 md:p-4 bg-gray-50 dark:bg-gray-900 min-h-screen font-sans">
    <!-- Encabezado -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4">
      <div class="flex items-center space-x-3">
        <div class="h-10 w-1 bg-gradient-to-b from-purple-500 to-pink-600 rounded-full"></div>
        <div>
          <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">Crear Venta a Crédito</h1>
          <p class="text-sm text-gray-500 dark:text-gray-400 flex items-center mt-1">
            <Icon icon="mdi:credit-card-outline" class="mr-1" />
            Jean Informatico - Sistema de Ventas
          </p>
        </div>
      </div>
      <button
        @click="volverAListado"
        class="px-4 py-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 shadow-sm hover:shadow flex items-center gap-2"
      >
        <Icon icon="mdi:arrow-left" class="text-lg" />
        Volver al listado
      </button>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <!-- Columna izquierda -->
      <div class="space-y-4">
        <!-- Tarjeta de Cliente -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-visible transition-all duration-200 hover:shadow-xl">
          <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 px-4 py-2 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg mr-3">
                <Icon icon="mdi:account" class="text-blue-600 dark:text-blue-400 text-xl" />
              </div>
              Información del Cliente
              <span class="ml-2 text-xs bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400 px-2 py-0.5 rounded-full">* Requerido</span>
            </h2>
          </div>
          
          <div class="p-4">
            <div class="flex space-x-1 bg-gray-100 dark:bg-gray-700 p-1 rounded-xl mb-4">
              <button
                @click="modoCliente = 'buscar'"
                :class="[
                  'flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200',
                  modoCliente === 'buscar'
                    ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                ]"
              >
                <Icon icon="mdi:magnify" class="inline mr-1" />
                Buscar Cliente
              </button>
              <button
                @click="modoCliente = 'crear'"
                :class="[
                  'flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200',
                  modoCliente === 'crear'
                    ? 'bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 shadow-sm'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                ]"
              >
                <Icon icon="mdi:account-plus" class="inline mr-1" />
                Nuevo Cliente
              </button>
            </div>

            <div v-if="modoCliente === 'buscar'" class="relative" style="z-index: 100;">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Buscar Cliente Existente
              </label>
              <div class="relative">
                <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  v-model="buscarCliente"
                  type="text"
                  placeholder="Nombre, documento, teléfono o email..."
                  class="w-full pl-10 pr-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm text-gray-900 dark:text-white dark:placeholder-gray-400"
                  @input="debounceBuscarClientes"
                  @focus="mostrarClientesSiHay"
                />
                <div v-if="buscandoClientes" class="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <Icon icon="mdi:loading" class="animate-spin text-blue-500 text-xl" />
                </div>
              </div>
              
              <div v-if="mostrarListaClientes && clientesEncontrados.length > 0" 
                   class="absolute mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl max-h-72 overflow-y-auto"
                   style="z-index: 9999; position: absolute; top: 100%; left: 0;">
                <div v-for="cliente in clientesEncontrados" 
                     :key="cliente.idCliente"
                     @click="seleccionarCliente(cliente)"
                     class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-100 dark:border-gray-700 last:border-b-0 transition-all duration-150">
                  <div class="flex items-start gap-3">
                    <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                      <Icon icon="mdi:account-circle" class="text-blue-600 dark:text-blue-400 text-xl" />
                    </div>
                    <div class="flex-1">
                      <div class="flex justify-between items-start">
                        <div>
                          <p class="font-semibold text-gray-800 dark:text-white">
                            {{ cliente.nombre }} {{ cliente.apellido || '' }}
                          </p>
                          <p class="text-sm text-gray-600 dark:text-gray-400 mt-0.5">
                            {{ formatearTipoDocumento(cliente.tipoDocumento) }}: 
                            <span class="font-mono">{{ cliente.documento }}</span>
                          </p>
                          <p v-if="cliente.telefono" class="text-xs text-gray-500 mt-1">
                            📞 {{ cliente.telefono }}
                          </p>
                        </div>
                        <Icon v-if="form.idCliente === cliente.idCliente" 
                              icon="mdi:check-circle" 
                              class="text-green-500 text-2xl" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-if="mostrarListaClientes && buscarCliente && !buscandoClientes && clientesEncontrados.length === 0" 
                   class="absolute mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl p-4 text-center">
                <p class="text-gray-500">No se encontraron clientes</p>
                <button 
                  @click="modoCliente = 'crear'"
                  class="mt-2 text-blue-600 hover:text-blue-700 text-sm font-medium"
                >
                  ¿Crear nuevo cliente?
                </button>
              </div>
            </div>

            <div v-if="modoCliente === 'crear'">
              <form @submit.prevent="guardarNuevoCliente" class="space-y-4">
                <div class="grid grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Tipo Documento <span class="text-red-500">*</span>
                    </label>
                    <select
                      v-model="nuevoCliente.tipoDocumento"
                      class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white"
                    >
                      <option value="">Seleccionar...</option>
                      <option value="cedula">Cédula de Identidad</option>
                      <option value="rif">RIF</option>
                      <option value="pasaporte">Pasaporte</option>
                      <option value="identificacion_extranjera">Identificación Extranjera</option>
                    </select>
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Número Documento <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="nuevoCliente.documento"
                      type="text"
                      :placeholder="getPlaceholderDocumento(nuevoCliente.tipoDocumento)"
                      class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white dark:placeholder-gray-400"
                      @blur="formatearDocumentoInput"
                    />
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Nombre <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="nuevoCliente.nombre"
                      type="text"
                      placeholder="Ej: Juan Carlos"
                      class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white dark:placeholder-gray-400"
                    />
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Apellido
                    </label>
                    <input
                      v-model="nuevoCliente.apellido"
                      type="text"
                      placeholder="Ej: Rodríguez"
                      class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white dark:placeholder-gray-400"
                    />
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Teléfono
                    </label>
                    <input
                      v-model="nuevoCliente.telefono"
                      type="text"
                      placeholder="0414-7470715"
                      class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white dark:placeholder-gray-400"
                      @blur="formatearTelefonoInput"
                    />
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Email
                    </label>
                    <input
                      v-model="nuevoCliente.email"
                      type="email"
                      placeholder="ejemplo@email.com"
                      class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white dark:placeholder-gray-400"
                    />
                  </div>
                  
                  <div class="col-span-2">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Dirección
                    </label>
                    <textarea
                      v-model="nuevoCliente.direccion"
                      rows="2"
                      placeholder="Dirección completa..."
                      class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none text-gray-900 dark:text-white dark:placeholder-gray-400"
                    ></textarea>
                  </div>
                </div>
                
                <div class="flex gap-3 pt-2">
                  <button
                    type="submit"
                    :disabled="!puedeGuardarCliente || guardandoCliente"
                    :class="[
                      'flex-1 px-4 py-2 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 font-medium text-sm',
                      puedeGuardarCliente && !guardandoCliente
                        ? 'bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:from-green-700 hover:to-emerald-700 shadow-lg hover:shadow-xl'
                        : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                    ]"
                  >
                    <Icon v-if="guardandoCliente" icon="mdi:loading" class="animate-spin text-lg" />
                    <Icon v-else icon="mdi:account-plus" class="text-lg" />
                    {{ guardandoCliente ? 'Guardando...' : 'Guardar y Seleccionar' }}
                  </button>
                  <button
                    type="button"
                    @click="modoCliente = 'buscar'"
                    class="flex-1 px-4 py-2 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 text-sm"
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
            
            <div v-if="clienteSeleccionado" class="mt-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-green-200 dark:border-green-800/50">
              <div class="flex items-start gap-3">
                <div class="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                  <Icon icon="mdi:account-check" class="text-green-600 dark:text-green-400 text-2xl" />
                </div>
                <div class="flex-1">
                  <div class="flex justify-between items-start">
                    <div>
                      <p class="font-semibold text-gray-800 dark:text-white text-lg">
                        {{ clienteSeleccionado.nombre }} {{ clienteSeleccionado.apellido || '' }}
                      </p>
                      <p class="text-sm text-gray-600 dark:text-gray-400 mt-0.5">
                        {{ formatearTipoDocumento(clienteSeleccionado.tipoDocumento) }}: 
                        <span class="font-mono">{{ clienteSeleccionado.documento }}</span>
                      </p>
                      <p v-if="clienteSeleccionado.telefono" class="text-xs text-gray-500 mt-1">
                        📞 {{ clienteSeleccionado.telefono }}
                      </p>
                    </div>
                    <button
                      @click="deseleccionarCliente"
                      class="p-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200"
                    >
                      <Icon icon="mdi:close" class="text-xl" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Información de la Venta a Crédito -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden transition-all duration-200 hover:shadow-xl">
          <div class="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-gray-800 dark:to-gray-800 px-4 py-2 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg mr-3">
                <Icon icon="mdi:credit-card-outline" class="text-purple-600 dark:text-purple-400 text-xl" />
              </div>
              Información del Crédito
            </h2>
          </div>
          
          <div class="p-4 space-y-3">
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Número de Factura
              </label>
              <div class="relative">
                <Icon icon="mdi:tag" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  v-model="form.numero_factura"
                  type="text"
                  readonly
                  class="w-full pl-10 pr-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50 text-gray-600 dark:text-gray-400 cursor-not-allowed font-mono text-sm"
                />
              </div>
            </div>

            <!-- Tipo de Crédito -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Tipo de Crédito <span class="text-red-500">*</span>
              </label>
              <div class="grid grid-cols-2 gap-3">
                <button
                  type="button"
                  @click="seleccionarTipoCredito('cacheas')"
                  :class="[
                    'p-4 rounded-xl border-2 transition-all duration-200 text-left',
                    tipoCredito === 'cacheas'
                      ? 'border-purple-500 bg-purple-50 dark:bg-purple-900/20'
                      : 'border-gray-200 dark:border-gray-700 hover:border-purple-300'
                  ]"
                >
                  <div class="flex items-center gap-3">
                    <div class="p-2 rounded-lg" :class="tipoCredito === 'cacheas' ? 'bg-purple-100 dark:bg-purple-800/50' : 'bg-gray-100 dark:bg-gray-700'">
                      <Icon icon="mdi:calendar-clock" class="text-xl" :class="tipoCredito === 'cacheas' ? 'text-purple-600' : 'text-gray-500'" />
                    </div>
                    <div>
                      <p class="font-semibold" :class="tipoCredito === 'cacheas' ? 'text-purple-700 dark:text-purple-300' : 'text-gray-700 dark:text-gray-300'">
                        Crédito Cachéas
                      </p>
                      <p class="text-xs text-gray-500">17% de recargo por producto</p>
                    </div>
                  </div>
                </button>

                <button
                  type="button"
                  @click="seleccionarTipoCredito('empresa')"
                  :class="[
                    'p-4 rounded-xl border-2 transition-all duration-200 text-left',
                    tipoCredito === 'empresa'
                      ? 'border-pink-500 bg-pink-50 dark:bg-pink-900/20'
                      : 'border-gray-200 dark:border-gray-700 hover:border-pink-300'
                  ]"
                >
                  <div class="flex items-center gap-3">
                    <div class="p-2 rounded-lg" :class="tipoCredito === 'empresa' ? 'bg-pink-100 dark:bg-pink-800/50' : 'bg-gray-100 dark:bg-gray-700'">
                      <Icon icon="mdi:domain" class="text-xl" :class="tipoCredito === 'empresa' ? 'text-pink-600' : 'text-gray-500'" />
                    </div>
                    <div>
                      <p class="font-semibold" :class="tipoCredito === 'empresa' ? 'text-pink-700 dark:text-pink-300' : 'text-gray-700 dark:text-gray-300'">
                        Crédito Empresa
                      </p>
                      <p class="text-xs text-gray-500">Sin recargo</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>

            <!-- Sección de Cuotas (solo para Cachéas) -->
            <div v-if="tipoCredito === 'cacheas'" class="space-y-3 mt-2 p-3 bg-purple-50 dark:bg-purple-900/10 rounded-xl border border-purple-200 dark:border-purple-800/30">
              <div class="flex items-center gap-2 text-purple-700 dark:text-purple-300">
                <Icon icon="mdi:calculator" class="text-xl" />
                <span class="font-semibold">Plan de Pago Cachéas</span>
              </div>

              <div class="bg-purple-100 dark:bg-purple-900/30 rounded-lg p-4">
                <div class="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span class="text-gray-600 dark:text-gray-400">Subtotal original:</span>
                    <p class="font-semibold text-gray-800 dark:text-white">$ {{ redondearYFormatear(subtotalOriginal) }}</p>
                  </div>
                  <div>
                    <span class="text-gray-600 dark:text-gray-400">Recargo 17%:</span>
                    <p class="font-semibold text-orange-600">$ {{ redondearYFormatear(recargoTotal) }}</p>
                  </div>
                  <div>
                    <span class="text-gray-600 dark:text-gray-400">Total con recargo:</span>
                    <p class="font-bold text-purple-700 dark:text-purple-300 text-lg">$ {{ redondearYFormatear(totalConRecargo) }}</p>
                  </div>
                </div>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Monto de la Inicial (USD) 
                  <span class="text-xs text-gray-500 ml-2">(Escribe el monto que desees, comienza en $0)</span>
                </label>
                <div class="relative">
                  <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">$</span>
                  <input
                    v-model.number="cuotas.inicialPersonalizada"
                    type="number"
                    step="0.01"
                    min="0"
                    :max="totalConRecargo"
                    class="w-full pl-8 pr-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white"
                    @input="actualizarInicial"
                  />
                </div>
                <p class="text-xs text-gray-500 mt-1">
                  Puedes poner cualquier monto desde $0 hasta ${{ redondearYFormatear(totalConRecargo) }}
                </p>
              </div>

              <div class="bg-purple-100 dark:bg-purple-900/30 rounded-lg p-4">
                <div class="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span class="text-gray-600 dark:text-gray-400">Total con recargo:</span>
                    <p class="font-semibold text-gray-800 dark:text-white">$ {{ redondearYFormatear(totalConRecargo) }}</p>
                  </div>
                  <div>
                    <span class="text-gray-600 dark:text-gray-400">Inicial a pagar:</span>
                    <p class="font-bold text-green-600 dark:text-green-400">$ {{ redondearYFormatear(cuotas.inicial) }}</p>
                  </div>
                  <div class="col-span-2">
                    <span class="text-gray-600 dark:text-gray-400">Saldo a financiar:</span>
                    <p class="font-semibold text-gray-800 dark:text-white">$ {{ redondearYFormatear(totalConRecargo - cuotas.inicial) }}</p>
                    <p class="text-xs text-gray-500">(Se dividirá en 3 cuotas semanales)</p>
                  </div>
                </div>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Fecha de Inicio <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="cuotas.fechaInicio"
                  type="date"
                  class="w-full px-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 text-sm text-gray-900 dark:text-white"
                  @change="calcularFechasCuotas"
                />
              </div>

              <div class="overflow-x-auto">
                <table class="w-full text-sm">
                  <thead class="bg-purple-100 dark:bg-purple-900/30 rounded-lg">
                    <tr>
                      <th class="px-3 py-2 text-left">Cuota</th>
                      <th class="px-3 py-2 text-left">Fecha de Pago</th>
                      <th class="px-3 py-2 text-right">Monto USD</th>
                      <th class="px-3 py-2 text-right">Monto Bs</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cuota, index) in cuotas.lista" :key="index" class="border-b border-gray-200 dark:border-gray-700">
                      <td class="px-3 py-2 font-medium">{{ index + 1 }}ra Cuota</td>
                      <td class="px-3 py-2">{{ formatearFecha(cuota.fechaPago) }}</td>
                      <td class="px-3 py-2 text-right text-purple-600 dark:text-purple-400 font-medium">
                        $ {{ redondearYFormatear(cuota.montoUsd) }}
                      </td>
                      <td class="px-3 py-2 text-right">
                        Bs. {{ formatearMontoBs(cuota.montoBs) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-if="tipoCredito === 'empresa'" class="mt-4 p-4 bg-pink-50 dark:bg-pink-900/10 rounded-xl border border-pink-200 dark:border-pink-800/30">
              <div class="flex items-center gap-3">
                <div class="p-2 bg-pink-100 dark:bg-pink-800/50 rounded-lg">
                  <Icon icon="mdi:handshake" class="text-2xl text-pink-600 dark:text-pink-400" />
                </div>
                <div>
                  <p class="font-semibold text-pink-700 dark:text-pink-300">Crédito Fiado</p>
                  <p class="text-sm text-gray-600 dark:text-gray-400">Sin recargo, pago en fecha acordada</p>
                </div>
              </div>
              <div class="mt-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Fecha de Pago Acordada
                </label>
                <input
                  v-model="creditoEmpresa.fechaPagoAcordada"
                  type="date"
                  class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white"
                />
              </div>
              <div class="mt-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Observaciones
                </label>
                <textarea
                  v-model="creditoEmpresa.observaciones"
                  rows="2"
                  placeholder="Ej: Pagará en 30 días..."
                  class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all duration-200 resize-none text-gray-900 dark:text-white dark:placeholder-gray-400"
                ></textarea>
              </div>

              <div class="mt-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Abono Inicial (USD) - Opcional
                </label>
                <div class="relative">
                  <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">$</span>
                  <input
                    v-model.number="cuotas.inicialPersonalizada"
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="0.00"
                    class="w-full pl-8 pr-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-white dark:placeholder-gray-400"
                    @input="actualizarInicial"
                  />
                </div>
              </div>
            </div>

            <!-- SECCIÓN DE PAGO DEL ABONO / INICIAL (SIEMPRE visible en Cachéas) -->
            <div v-if="(tipoCredito === 'cacheas') || (tipoCredito === 'empresa' && cuotas.inicial > 0)" class="mt-4 p-4 bg-emerald-50 dark:bg-emerald-900/10 rounded-xl border-2 border-emerald-500/30 animate-fadeIn">
              <h3 class="text-md font-bold text-emerald-800 dark:text-emerald-300 mb-4 flex items-center gap-2">
                <div class="p-1.5 bg-emerald-100 dark:bg-emerald-800/50 rounded-lg">
                  <Icon icon="mdi:cash-multiple" class="text-emerald-600 dark:text-emerald-400" />
                </div>
                Información del Pago (Abono / Inicial)
                <span v-if="cuotas.inicial === 0" class="text-xs font-normal text-emerald-600 dark:text-emerald-400 ml-2">
                  (opcional - solo si abonas algo ahora)
                </span>
              </h3>

              <!-- Aviso cuando no hay inicial -->
              <div v-if="cuotas.inicial === 0" class="mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800/50">
                <div class="flex items-start gap-2">
                  <Icon icon="mdi:information-outline" class="text-blue-600 dark:text-blue-400 text-xl shrink-0 mt-0.5" />
                  <div>
                    <p class="text-sm font-semibold text-blue-800 dark:text-blue-300">No hay abono inicial</p>
                    <p class="text-xs text-blue-600 dark:text-blue-400 mt-0.5">
                      Escribe un monto mayor a $0 en "Monto de la Inicial" arriba para poder registrar el método de pago aquí.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Selector de método (solo si hay inicial) -->
              <div v-if="cuotas.inicial > 0" class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Método de Pago <span class="text-red-500">*</span></label>
                <select v-model="form.idMetodoPagoInicial" class="w-full px-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-sm text-gray-900 dark:text-white" @change="onMetodoPagoInicialChange">
                  <option value="">Seleccionar método...</option>
                  <option v-for="metodo in metodosPago" :key="metodo.idMetodoPago" :value="metodo.idMetodoPago">{{ metodo.nombre }}</option>
                </select>
              </div>
              
              <!-- PUNTO DE VENTA -->
              <div v-if="esPuntoVentaInicial && cuotas.inicial > 0" class="space-y-4 p-5 bg-gradient-to-r from-yellow-50 to-amber-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border-2 border-yellow-400 dark:border-yellow-600">
                <div class="flex items-center gap-2 text-yellow-800 dark:text-yellow-200">
                  <Icon icon="mdi:credit-card" class="text-xl" />
                  <span class="font-semibold">Punto de Venta</span>
                  <span class="ml-2 text-xs bg-yellow-200 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300 px-2 py-0.5 rounded-full">Requiere referencia (4 dígitos)</span>
                </div>
                
                <div class="bg-yellow-100 dark:bg-yellow-900/30 p-4 rounded-xl border border-yellow-200 dark:border-yellow-800">
                  <p class="text-sm font-medium text-yellow-800 dark:text-yellow-200 mb-2 flex items-center gap-2">
                    <Icon icon="mdi:form-textbox" class="text-lg" />
                    Datos de la Transacción del Punto
                  </p>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">N° de Referencia del Punto (4 dígitos) <span class="text-red-500">*</span></label>
                    <input 
                      v-model="puntoVenta.referencia" 
                      type="text" 
                      inputmode="numeric"
                      maxlength="4" 
                      placeholder="Ej: 1234" 
                      class="w-full px-4 py-3 border-2 border-yellow-400 dark:border-yellow-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-yellow-500 text-center text-2xl font-mono tracking-widest text-gray-900 dark:text-white dark:placeholder-gray-400" 
                      @input="validarPuntoVenta" 
                    />
                  </div>
                  <div class="mt-3 p-2 bg-white dark:bg-gray-800 rounded-lg text-xs flex justify-between items-center">
                    <span class="text-gray-500 dark:text-gray-400">Referencia de Punto:</span> 
                    <span class="font-mono font-bold text-gray-800 dark:text-gray-200">{{ puntoVenta.referencia || '----' }}</span>
                  </div>
                </div>
              </div>
              
              <!-- PAGO MÓVIL -->
              <div v-if="esPagoMovilInicial && cuotas.inicial > 0" class="space-y-4 p-4 bg-gradient-to-r from-blue-50 to-sky-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-blue-200 dark:border-blue-800/50">
                <div class="flex items-center gap-2 text-blue-800 dark:text-blue-200">
                  <Icon icon="mdi:cellphone" class="text-xl" />
                  <span class="font-semibold">Pago Móvil</span>
                </div>

                <div class="space-y-3">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Cuenta Destino <span class="text-red-500">*</span></label>
                  <select v-model="pagoInicialMovil.banco_destino" class="w-full px-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm text-gray-900 dark:text-white" @change="autocompletarDatosBancoDestinoInicial">
                    <option :value="null">Seleccionar cuenta...</option>
                    <option v-for="c in bancosEmpresa" :key="c.idCuentaBancaria" :value="c.idCuentaBancaria">
                      {{ c.bancoNombre }} — {{ c.titularNombreCompleto }} ({{ c.numeroCuenta }})
                    </option>
                  </select>

                  <!-- TARJETA GRANDE -->
                  <div v-if="cuentaInicialMovilSeleccionada" class="mt-3 p-4 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl shadow-xl border border-blue-300/30">
                    <div class="flex items-center gap-3 mb-3 pb-3 border-b border-white/20">
                      <div class="p-2.5 bg-white/20 rounded-xl shrink-0">
                        <Icon icon="mdi:account-tie" class="text-white text-3xl" />
                      </div>
                      <div class="min-w-0 flex-1">
                        <p class="text-[10px] font-black text-blue-100 uppercase tracking-widest mb-0.5">Titular</p>
                        <p class="text-white font-black text-lg leading-tight truncate">
                          {{ cuentaInicialMovilSeleccionada.titularNombreCompleto }}
                        </p>
                        <p class="text-blue-100 font-bold text-sm font-mono">
                          {{ cuentaInicialMovilSeleccionada.titularTipoDocumento === 'rif' ? 'RIF' : 'C.I.' }}: {{ cuentaInicialMovilSeleccionada.titularDocumento }}
                        </p>
                      </div>
                    </div>

                    <div class="flex items-center gap-3 mb-3 pb-3 border-b border-white/20">
                      <div class="p-2 bg-white/20 rounded-lg shrink-0">
                        <Icon icon="mdi:phone" class="text-white text-xl" />
                      </div>
                      <div class="flex-1">
                        <p class="text-[10px] font-black text-blue-100 uppercase tracking-widest mb-0.5">Teléfono</p>
                        <p class="text-white font-black text-lg font-mono tracking-wide">
                          {{ cuentaInicialMovilSeleccionada.titularTelefono || 'No registrado' }}
                        </p>
                      </div>
                    </div>

                    <div v-if="cuentaInicialMovilSeleccionada.pmBancoCodigo || cuentaInicialMovilSeleccionada.pmTelefono" class="flex items-center gap-3 bg-white/15 rounded-xl p-3 border border-white/20">
                      <div class="p-2 bg-white/25 rounded-lg shrink-0">
                        <Icon icon="mdi:cellphone" class="text-white text-xl" />
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="text-[10px] font-black text-blue-100 uppercase tracking-widest mb-0.5">Pago Móvil</p>
                        <p class="text-white font-black text-base font-mono tracking-wide truncate">
                          {{ cuentaInicialMovilSeleccionada.pmBancoCodigo || cuentaInicialMovilSeleccionada.bancoCodigo }} · {{ cuentaInicialMovilSeleccionada.pmTelefono || cuentaInicialMovilSeleccionada.titularTelefono }}
                        </p>
                      </div>
                    </div>

                    <div v-if="cuentaInicialMovilSeleccionada.numeroCuenta" class="mt-3 flex items-center justify-between gap-2 text-[10px] font-mono text-blue-100 bg-black/20 rounded-lg px-3 py-2">
                      <span class="font-black uppercase tracking-widest">N° Cuenta:</span>
                      <span class="font-bold truncate">{{ cuentaInicialMovilSeleccionada.numeroCuenta }}</span>
                    </div>
                  </div>

                  <div class="grid grid-cols-2 gap-2">
                    <input v-model="pagoInicialMovil.cedula" type="text" placeholder="Cédula" class="px-4 py-2 border rounded-xl text-sm dark:bg-gray-700 text-gray-900 dark:text-white dark:placeholder-gray-400" />
                    <input v-model="pagoInicialMovil.telefono" type="text" placeholder="Teléfono" class="px-4 py-2 border rounded-xl text-sm dark:bg-gray-700 text-gray-900 dark:text-white dark:placeholder-gray-400" />
                    <select v-model="pagoInicialMovil.banco_origen" class="px-4 py-2 border rounded-xl text-sm dark:bg-gray-700 text-gray-900 dark:text-white">
                      <option value="">Banco Origen...</option>
                      <option v-for="b in bancosVenezuela" :key="b" :value="b">{{ b }}</option>
                    </select>
                    <input v-model="pagoInicialMovil.referencia" type="text" placeholder="Referencia" class="px-4 py-2 border rounded-xl text-sm dark:bg-gray-700 text-gray-900 dark:text-white dark:placeholder-gray-400" />
                  </div>
                </div>
              </div>
              
              <!-- TRANSFERENCIA -->
              <div v-if="esTransferenciaInicial && cuotas.inicial > 0" class="space-y-4 p-4 bg-gradient-to-r from-purple-50 to-violet-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-purple-200 dark:border-purple-800/50">
                <div class="flex items-center gap-2 text-purple-800 dark:text-purple-200">
                  <Icon icon="mdi:bank-transfer" class="text-xl" />
                  <span class="font-semibold">Transferencia</span>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Cuenta Destino <span class="text-red-500">*</span></label>
                  <select v-model="pagoInicialTransferencia.banco_destino" class="w-full px-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-purple-500 text-sm text-gray-900 dark:text-white" @change="autocompletarDatosTransferenciaInicial">
                    <option :value="null">Seleccionar cuenta...</option>
                    <option v-for="c in bancosEmpresa" :key="c.idCuentaBancaria" :value="c.idCuentaBancaria">
                      {{ c.bancoNombre }} — {{ c.titularNombreCompleto }} ({{ c.numeroCuenta }})
                    </option>
                  </select>

                  <!-- TARJETA GRANDE -->
                  <div v-if="cuentaInicialTransferenciaSeleccionada" class="mt-3 p-4 bg-gradient-to-br from-purple-500 to-violet-600 rounded-2xl shadow-xl border border-purple-300/30">
                    <div class="flex items-center gap-3 mb-3 pb-3 border-b border-white/20">
                      <div class="p-2.5 bg-white/20 rounded-xl shrink-0">
                        <Icon icon="mdi:account-tie" class="text-white text-3xl" />
                      </div>
                      <div class="min-w-0 flex-1">
                        <p class="text-[10px] font-black text-purple-100 uppercase tracking-widest mb-0.5">Titular</p>
                        <p class="text-white font-black text-lg leading-tight truncate">
                          {{ cuentaInicialTransferenciaSeleccionada.titularNombreCompleto }}
                        </p>
                        <p class="text-purple-100 font-bold text-sm font-mono">
                          {{ cuentaInicialTransferenciaSeleccionada.titularTipoDocumento === 'rif' ? 'RIF' : 'C.I.' }}: {{ cuentaInicialTransferenciaSeleccionada.titularDocumento }}
                        </p>
                      </div>
                    </div>

                    <div class="flex items-center gap-3 mb-3 pb-3 border-b border-white/20">
                      <div class="p-2 bg-white/20 rounded-lg shrink-0">
                        <Icon icon="mdi:phone" class="text-white text-xl" />
                      </div>
                      <div class="flex-1">
                        <p class="text-[10px] font-black text-purple-100 uppercase tracking-widest mb-0.5">Teléfono</p>
                        <p class="text-white font-black text-lg font-mono tracking-wide">
                          {{ cuentaInicialTransferenciaSeleccionada.titularTelefono || 'No registrado' }}
                        </p>
                      </div>
                    </div>

                    <div v-if="cuentaInicialTransferenciaSeleccionada.numeroCuenta" class="bg-white/15 rounded-xl p-3 border border-white/20">
                      <div class="flex items-center gap-2 mb-1">
                        <Icon icon="mdi:bank" class="text-white text-base" />
                        <p class="text-[10px] font-black text-purple-100 uppercase tracking-widest">Cuenta</p>
                      </div>
                      <p class="text-white font-black text-base font-mono tracking-wide break-all">
                        {{ cuentaInicialTransferenciaSeleccionada.numeroCuenta }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="grid grid-cols-2 gap-2">
                  <input v-model="pagoInicialTransferencia.referencia" type="text" placeholder="Referencia" class="px-4 py-2 border rounded-xl text-sm dark:bg-gray-700 text-gray-900 dark:text-white dark:placeholder-gray-400" />
                  <select v-model="pagoInicialTransferencia.banco_origen" class="px-4 py-2 border rounded-xl text-sm dark:bg-gray-700 text-gray-900 dark:text-white">
                    <option value="">Banco Origen...</option>
                    <option v-for="b in bancosVenezuela" :key="b" :value="b">{{ b }}</option>
                  </select>
                </div>
              </div>
              
              <!-- EFECTIVO -->
              <div v-if="esEfectivoInicial && cuotas.inicial > 0" class="p-4 bg-green-50 dark:bg-gray-800 rounded-xl border border-green-200 dark:border-green-800/50 flex items-center gap-3 text-green-800 dark:text-green-200">
                <Icon icon="mdi:cash" class="text-2xl" />
                <span class="font-semibold">Efectivo (Abono)</span>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Estado
              </label>
              <div class="relative">
                <Icon icon="mdi:clock-outline" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-orange-500" />
                <input
                  :value="tipoCredito === 'cacheas' ? 'Pendiente (Inicial pendiente)' : 'Pendiente de Pago'"
                  type="text"
                  readonly
                  class="w-full pl-10 pr-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50 cursor-not-allowed font-medium text-orange-600 dark:text-orange-400 text-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Columna derecha -->
      <div class="space-y-4">
        <!-- Productos -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-orange-50 to-amber-50 dark:from-gray-800 dark:to-gray-800 px-6 py-4 border-b">
            <div class="flex justify-between items-center">
              <h2 class="text-lg font-semibold text-gray-800 dark:text-white flex items-center">
                <div class="p-2 bg-orange-100 dark:bg-orange-900/30 rounded-lg mr-3">
                  <Icon icon="mdi:package-variant" class="text-orange-600 dark:text-orange-400 text-xl" />
                </div>
                Productos de la Venta
              </h2>
              <button
                @click="mostrarModalProductos"
                :disabled="!clienteSeleccionado"
                :class="[
                  'px-4 py-2 rounded-xl transition-all duration-200 flex items-center gap-2 text-sm font-medium',
                  clienteSeleccionado
                    ? 'bg-gradient-to-r from-orange-600 to-amber-600 text-white hover:from-orange-700 hover:to-amber-700 shadow-md hover:shadow-lg'
                    : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                ]"
              >
                <Icon icon="mdi:plus" class="text-lg" />
                Agregar Producto
              </button>
            </div>
          </div>
          
          <div class="p-4">
            <div class="mb-4">
              <div class="relative">
                <Icon icon="mdi:barcode-scan" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-500 text-xl" />
                <input 
                  ref="lectorCreditoInput"
                  v-model="codigoEscaneadoCredito"
                  type="text"
                  placeholder="Escanea el código del producto..."
                  @keydown.enter="buscarProductoPorCodigoCredito"
                  class="w-full pl-10 sm:pl-12 pr-4 py-2 sm:py-3 bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-300 dark:border-blue-700 rounded-xl text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all outline-none text-gray-900 dark:text-white dark:placeholder-gray-400"
                  :disabled="buscandoProductoCredito || !clienteSeleccionado"
                  autofocus
                />
                <div v-if="buscandoProductoCredito" class="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <div class="w-4 h-4 sm:w-5 sm:h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
              </div>
              
              <div v-if="productoEncontradoCredito" class="mt-2 p-3 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-800 flex items-start gap-3">
                <div class="w-12 h-12 sm:w-16 sm:h-16 rounded-lg overflow-hidden bg-white flex-shrink-0 border border-gray-200">
                  <img 
                    v-if="getImageUrl(productoEncontradoCredito.imagen)" 
                    :src="getImageUrl(productoEncontradoCredito.imagen)" 
                    :alt="productoEncontradoCredito.nombre"
                    class="w-full h-full object-cover"
                    @error="handleImageError"
                  />
                  <div v-else class="w-full h-full flex items-center justify-center text-gray-300">
                    <Icon icon="mdi:package-variant" class="text-2xl sm:text-3xl" />
                  </div>
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex justify-between items-start">
                    <div>
                      <p class="font-semibold text-gray-800 dark:text-white text-sm">{{ productoEncontradoCredito.nombre }}</p>
                      <p class="text-xs text-gray-500 dark:text-gray-400">Código: {{ productoEncontradoCredito.codigo }}</p>
                      <p class="text-xs text-gray-500 dark:text-gray-400">Stock: {{ productoEncontradoCredito.stock || 0 }} | Precio: ${{ (productoEncontradoCredito.precio_venta_usd || 0).toFixed(2) }}</p>
                      <p v-if="tipoCredito === 'cacheas'" class="text-xs text-orange-600 dark:text-orange-400">Con recargo 17%: ${{ ((productoEncontradoCredito.precio_venta_usd || 0) * 1.17).toFixed(2) }}</p>
                    </div>
                    <div class="flex gap-1">
                      <button @click="agregarProductoDesdeLectorCredito(productoEncontradoCredito)" class="px-3 py-1 bg-green-600 text-white rounded-lg text-xs hover:bg-green-700 transition-all flex items-center gap-1">
                        <Icon icon="mdi:plus" class="text-sm" /> Agregar
                      </button>
                      <button @click="productoEncontradoCredito = null" class="p-1 text-gray-400 hover:text-gray-600">
                        <Icon icon="mdi:close" class="text-sm" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-if="busquedaFallidaCredito" class="mt-2 p-3 bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-200 dark:border-red-800 text-center">
                <p class="text-red-600 dark:text-red-400 text-sm">Producto no encontrado: "{{ codigoEscaneadoCredito }}"</p>
                <button @click="busquedaFallidaCredito = false; codigoEscaneadoCredito = ''" class="mt-1 text-xs text-gray-500 hover:text-gray-700">Cerrar</button>
              </div>
            </div>

            <div v-if="!clienteSeleccionado" class="mb-4 p-4 bg-gray-100 dark:bg-gray-700/50 rounded-xl">
              <div class="flex items-center gap-3 text-gray-600 dark:text-gray-400">
                <Icon icon="mdi:alert-circle" class="text-2xl" />
                <p class="text-sm">Selecciona un cliente para agregar productos</p>
              </div>
            </div>
            
            <div v-if="productosSeleccionados.length > 0" class="space-y-3 max-h-96 overflow-y-auto pr-2">
              <div v-for="(producto, index) in productosSeleccionados" 
                   :key="index"
                   class="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-gray-200 dark:border-gray-700">
                <div class="flex justify-between items-start">
                  <div class="flex-1">
                    <div class="flex justify-between items-start">
                      <div>
                        <p class="font-semibold text-gray-800 dark:text-white">{{ producto.nombre }}</p>
                        <p class="text-xs text-gray-500 dark:text-gray-400">Código: {{ producto.codigo }}</p>
                        <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Stock: {{ producto.stock || 0 }} uds</p>
                      </div>
                      <button
                        @click="removerProducto(index)"
                        class="p-1.5 text-red-600 hover:text-red-800 rounded-lg"
                      >
                        <Icon icon="mdi:delete" class="text-lg" />
                      </button>
                    </div>
                    
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
                      <div>
                        <label class="block text-xs text-gray-500 mb-1">Cantidad</label>
                        <input
                          v-model.number="producto.cantidad"
                          type="number"
                          min="1"
                          class="w-full px-3 py-2 border rounded-lg text-center text-gray-900 dark:text-white dark:bg-gray-700"
                          @change="actualizarSubtotalProducto(producto)"
                        />
                      </div>
                      
                      <div>
                        <label class="block text-xs text-gray-500 mb-1">Precio Unitario USD</label>
                        <div class="relative">
                          <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">$</span>
                          <input
                            v-model.number="producto.precio_unitario_usd"
                            type="number"
                            min="0"
                            step="0.01"
                            class="w-full pl-8 pr-3 py-2 border rounded-lg text-right font-medium text-gray-900 dark:text-white dark:bg-gray-700"
                            @change="actualizarSubtotalProducto(producto)"
                          />
                        </div>
                      </div>
                      
                      <div class="md:col-span-2">
                        <label class="block text-xs text-gray-500 mb-1">Garantía (meses)</label>
                        <input
                          v-model.number="producto.garantia_meses"
                          type="number"
                          min="0"
                          step="1"
                          class="w-full px-3 py-2 border rounded-lg text-center text-gray-900 dark:text-white dark:bg-gray-700"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-else-if="clienteSeleccionado" class="text-center py-12">
              <div class="p-4 bg-gray-50 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                <Icon icon="mdi:cart-outline" class="text-4xl text-gray-400" />
              </div>
              <p class="text-gray-600 font-medium">No hay productos agregados</p>
              <p class="text-xs text-gray-500 mt-1">Escanea un código o haz clic en "Agregar"</p>
            </div>
          </div>
        </div>

        <!-- Resumen y Total -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-gray-800 dark:to-gray-800 px-6 py-4 border-b">
            <h2 class="text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-2 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg mr-3">
                <Icon icon="mdi:calculator" class="text-indigo-600 dark:text-indigo-400 text-xl" />
              </div>
              Resumen de la Venta
            </h2>
          </div>
          
          <div class="p-4 space-y-3">
            <div class="space-y-3">
              <div class="flex justify-between items-center">
                <span class="text-gray-600 dark:text-gray-400">Subtotal original:</span>
                <span class="font-semibold text-gray-800 dark:text-white">$ {{ redondearYFormatear(subtotalOriginal) }}</span>
              </div>
              
              <div class="flex justify-between items-center">
                <span class="text-gray-600 dark:text-gray-400">Descuento:</span>
                <div class="flex items-center gap-2">
                  <span class="text-gray-800 dark:text-white">$</span>
                  <input
                    v-model.number="form.descuento_usd"
                    type="number"
                    min="0"
                    step="0.01"
                    class="w-24 px-3 py-2 border rounded-lg text-right text-gray-900 dark:text-white dark:bg-gray-700"
                    @change="calcularTotales"
                  />
                </div>
              </div>
              
              <div v-if="tipoCredito === 'cacheas'" class="flex justify-between items-center bg-orange-50 p-3 rounded-xl">
                <span class="text-gray-600">Recargo 17% (por producto):</span>
                <span class="font-semibold text-orange-600">$ {{ redondearYFormatear(recargoTotal) }}</span>
              </div>
              
              <div class="border-t pt-4 mt-2">
                <div class="flex justify-between items-center text-lg">
                  <span class="font-bold text-gray-800 dark:text-white">Total con recargo:</span>
                  <div class="flex items-center gap-2">
                    <span class="font-bold text-2xl text-purple-600">$</span>
                    <input
                      v-model.number="totalConRecargo"
                      type="number"
                      step="0.01"
                      class="w-32 px-3 py-2 bg-purple-50 dark:bg-purple-900/20 border-2 border-purple-300 dark:border-purple-700 rounded-xl text-right font-bold text-2xl text-purple-600 focus:ring-2 focus:ring-purple-500 outline-none transition-all"
                      @input="actualizarRecargoDesdeTotal"
                    />
                  </div>
                </div>
                
                <div v-if="tipoCredito === 'cacheas'" class="text-xs text-gray-500 mt-1 text-right">
                  ({{ redondearYFormatear(subtotalOriginal) }} + {{ redondearYFormatear(recargoTotal) }} de recargo)
                </div>
                
                <div v-if="tasaSeleccionada" class="flex justify-between items-center mt-3 text-sm bg-gray-50 dark:bg-gray-700/30 p-3 rounded-xl border border-gray-200 dark:border-gray-700">
                  <span class="text-gray-600 dark:text-gray-400">Total en Bs:</span>
                  <span class="font-semibold text-gray-800 dark:text-white">Bs. {{ formatearMontoBs(totalConRecargo * tasaSeleccionada.precio_usd_bs) }}</span>
                </div>
              </div>
            </div>

            <div class="border-t pt-4 space-y-4">
              <div v-if="tasaSeleccionada">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tasa de Cambio (Bs/USD)</label>
                <div class="p-3 bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-gray-200 dark:border-gray-700">
                  <div class="grid grid-cols-2 gap-2 text-sm">
                    <div><span class="text-gray-500 dark:text-gray-400 block text-xs">Fuente:</span><span class="font-medium text-gray-800 dark:text-white">{{ tasaSeleccionada.fuenteTasa?.nombre || tasaSeleccionada.nombreFuente || 'N/A' }}</span></div>
                    <div><span class="text-gray-500 dark:text-gray-400 block text-xs">Tasa:</span><span class="font-medium text-emerald-600 dark:text-emerald-400">Bs. {{ tasaSeleccionada.precio_usd_bs.toFixed(2) }}</span></div>
                  </div>
                </div>
              </div>
              
              <div>
                <label class="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">Vendedor *</label>
                <div class="relative">
                  <Icon icon="mdi:account-tie" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-purple-500" />
                  <input 
                    :value="vendedorActual ? `${vendedorActual.nombre} ${vendedorActual.apellido}` : 'Cargando...'" 
                    type="text" 
                    readonly 
                    class="w-full pl-10 pr-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50 text-gray-700 dark:text-gray-300 cursor-not-allowed font-medium text-sm" 
                  />
                </div>
              </div>
            </div>
            
            <div class="pt-4">
              <button @click="crearVentaCredito" :disabled="!puedeCrearVentaCredito || guardando" :class="['w-full px-4 py-3 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 font-semibold text-lg shadow-lg', puedeCrearVentaCredito && !guardando ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:from-purple-700 hover:to-pink-700' : 'bg-gray-200 text-gray-500 cursor-not-allowed']">
                <Icon v-if="guardando" icon="mdi:loading" class="animate-spin text-xl" />
                <Icon v-else icon="mdi:credit-card-outline" class="text-xl" />
                {{ guardando ? 'Creando Venta...' : 'Crear Venta a Crédito' }}
              </button>
              <div v-if="!puedeCrearVentaCredito && !guardando" class="mt-3 space-y-1">
                <p v-if="!clienteSeleccionado || !(clienteSeleccionado.idCliente || clienteSeleccionado.id)" class="text-xs text-red-600 flex items-center gap-1"><Icon icon="mdi:alert-circle" /> Falta: Seleccionar un cliente (ID requerido)</p>
                <p v-else-if="productosSeleccionados.length === 0" class="text-xs text-red-600 flex items-center gap-1"><Icon icon="mdi:alert-circle" /> Falta: Agregar al menos un producto</p>
                <p v-else-if="!form.idVendedor" class="text-xs text-red-600 flex items-center gap-1"><Icon icon="mdi:alert-circle" /> Falta: Seleccionar vendedor</p>
                <p v-else-if="!form.idTasaVenta" class="text-xs text-red-600 flex items-center gap-1"><Icon icon="mdi:alert-circle" /> Falta: Seleccionar tasa de cambio</p>
                <p v-else-if="tipoCredito === 'cacheas' && cuotas.inicial > 0 && !form.idMetodoPagoInicial" class="text-xs text-red-600 flex items-center gap-1"><Icon icon="mdi:alert-circle" /> Falta: Seleccionar método de pago de la inicial</p>
                <p v-else-if="tipoCredito === 'cacheas' && cuotas.inicial > 0 && esPagoMovilInicial && !validarPagoMovilInicial" class="text-xs text-red-600 flex items-center gap-1"><Icon icon="mdi:alert-circle" /> Falta: Completar todos los datos de pago móvil</p>
                <p v-else-if="tipoCredito === 'cacheas' && cuotas.inicial > 0 && esTransferenciaInicial && !validarTransferenciaInicial" class="text-xs text-red-600 flex items-center gap-1"><Icon icon="mdi:alert-circle" /> Falta: Completar todos los datos de transferencia</p>
                <p v-else-if="tipoCredito === 'cacheas' && cuotas.inicial > 0 && esPuntoVentaInicial && !validarPuntoVentaInicial" class="text-xs text-red-600 flex items-center gap-1"><Icon icon="mdi:alert-circle" /> Falta: Ingresar número de referencia del punto (4 dígitos)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Teleport to="body">
      <div v-if="showModalProductos" class="fixed inset-0 z-50 overflow-hidden flex items-center justify-center p-2 sm:p-4" role="dialog">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="cerrarModalProductos"></div>

        <div class="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden transform transition-all scale-100 animate-fadeIn">
          <div class="p-4 sm:p-6 border-b dark:border-gray-700">
            <div class="flex justify-between items-center">
              <h3 class="text-xl font-bold text-gray-800 dark:text-white">Seleccionar Productos</h3>
              <button @click="cerrarModalProductos" class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl">
                <Icon icon="mdi:close" class="text-2xl text-gray-600 dark:text-gray-300" />
              </button>
            </div>
            <div class="mt-4 relative">
              <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input v-model="buscarProducto" type="text" placeholder="Buscar producto..." class="w-full pl-10 pr-4 py-3 border rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-purple-500 text-gray-900 dark:text-white dark:placeholder-gray-400" @input="debounceBuscarProductos" />
            </div>
          </div>
          
          <div class="p-4 sm:p-6 overflow-y-auto flex-1 custom-scrollbar">
            <div v-if="cargandoProductos" class="text-center py-12">
              <div class="inline-block animate-spin rounded-full h-8 w-8 border-3 border-orange-500 border-t-transparent"></div>
            </div>
            <div v-else-if="productosParaMostrar.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div v-for="producto in productosParaMostrar" :key="producto.idProducto" @click="agregarProducto(producto)" class="p-4 border rounded-xl hover:border-purple-500 cursor-pointer transition-all hover:shadow-lg bg-white dark:bg-gray-800 dark:border-gray-700">
                <div class="flex gap-3">
                  <div class="w-16 h-16 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0 border border-gray-200">
                    <img 
                      v-if="getImageUrl(producto.imagen)" 
                      :src="getImageUrl(producto.imagen)" 
                      :alt="producto.nombre"
                      class="w-full h-full object-cover"
                      @error="handleImageError"
                    />
                    <div v-else class="w-full h-full flex items-center justify-center text-gray-300">
                      <Icon icon="mdi:package-variant" class="text-3xl" />
                    </div>
                  </div>
                  <div class="flex-1">
                    <h4 class="font-semibold text-gray-800 dark:text-white">{{ producto.nombre }}</h4>
                    <p class="text-xs text-gray-500 dark:text-gray-400">Código: {{ producto.codigo }}</p>
                    <div class="mt-2 flex justify-between items-center">
                      <span class="text-sm text-gray-600 dark:text-gray-400">Precio:</span>
                      <span class="text-lg font-bold text-purple-600 dark:text-purple-400">$ {{ redondearYFormatear(producto.precio_venta_usd || 0) }}</span>
                    </div>
                    <div v-if="tipoCredito === 'cacheas'" class="mt-1 flex justify-between items-center">
                      <span class="text-xs text-gray-500 dark:text-gray-400">Con recargo 17%:</span>
                      <span class="text-sm font-semibold text-orange-600 dark:text-orange-400">$ {{ redondearYFormatear((producto.precio_venta_usd || 0) * 1.17) }}</span>
                    </div>
                    <div v-if="productoYaAgregado(producto)" class="mt-2">
                      <span class="inline-flex items-center gap-1 text-xs bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 px-2 py-1 rounded-lg">
                        <Icon icon="mdi:check" /> Ya agregado
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-12">
              <Icon icon="mdi:package-variant" class="text-5xl text-gray-400 mx-auto mb-3" />
              <p class="text-gray-600 dark:text-gray-400">No hay productos disponibles</p>
            </div>
          </div>
          
          <div class="p-4 sm:p-6 border-t bg-gray-50 dark:bg-gray-800/50 dark:border-gray-700">
            <div class="flex justify-between items-center">
              <p class="text-sm text-gray-600 dark:text-gray-400">{{ productosSeleccionados.length }} productos seleccionados</p>
              <button @click="cerrarModalProductos" class="px-6 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-medium shadow-md hover:shadow-lg transition-all">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <Teleport to="body">
      <div v-if="showConfirmModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[60]">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
          <div class="p-6">
            <div class="flex justify-center mb-4">
              <div class="p-3 rounded-full" :class="confirmModalIconClass">
                <Icon :icon="confirmModalIcon" class="text-4xl" :class="confirmModalIconColor" />
              </div>
            </div>
            <h3 class="text-xl font-bold text-center text-gray-800 dark:text-white mb-2">{{ confirmModalTitle }}</h3>
            <p class="text-center text-gray-600 dark:text-gray-400 mb-6" v-html="confirmModalMessage"></p>
            <div class="flex gap-3">
              <button v-if="confirmModalType !== 'info'" @click="cancelarConfirmacion" class="flex-1 px-4 py-3 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200">{{ confirmModalCancelText }}</button>
              <button @click="aceptarConfirmacion" class="flex-1 px-4 py-3 rounded-xl transition-all duration-200 font-medium text-white" :class="confirmModalConfirmClass">{{ confirmModalConfirmText }}</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import { crearVentaCredito as apiCrearVentaCredito, registrarPagoVenta, obtenerSiguienteNumeroFactura } from '@/api/ventas.js';
import { obtenerClientes, crearCliente, formatearDocumento, formatearTelefonoVenezolano } from '@/api/clientes.js';
import { obtenerProductos, obtenerProductoPorCodigo, obtenerProductoPorCodigoBarras, obtenerUrlImagen } from '@/api/productos.js';
import { obtenerVendedores, obtenerVendedorPorIdUsuario } from '@/api/vendedores.js';
import { obtenerTasasVenta } from '@/api/tasaVenta.js';
import { obtenerMetodosPago } from '@/api/metodosPago.api.js';
import { getCurrentUser } from "@/utils/permissionUtils";
import { imprimirFactura } from '@/utils/facturaGenerator.js';
import {
  obtenerBancosPagoMovil,
  obtenerCuentasPropias,
  crearPagoCuenta
} from '@/api/bancos.js';

export default {
  name: 'VentasCreateCredito',
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      form: {
        numero_factura: '',
        fecha_venta: new Date().toISOString(),
        tipo_venta: 'CREDITO',
        descuento_usd: 0,
        descuento_bs: 0,
        tasa_bs_usd: 0,
        idFuenteTasaVenta: null,
        idTasaVenta: '',
        idVendedor: null,
        idCliente: null,
        observaciones: '',
        estado: 'Pendiente',
        idMetodoPagoInicial: ''
      },
      
      tipoCredito: '',
      
      cuotas: {
        fechaInicio: '',
        inicial: 0,
        inicialPersonalizada: 0,
        lista: [
          { numero: 1, fechaPago: '', montoUsd: 0, montoBs: 0, estado: 'pendiente' },
          { numero: 2, fechaPago: '', montoUsd: 0, montoBs: 0, estado: 'pendiente' },
          { numero: 3, fechaPago: '', montoUsd: 0, montoBs: 0, estado: 'pendiente' }
        ]
      },
      
      creditoEmpresa: {
        fechaPagoAcordada: '',
        observaciones: ''
      },
      
      pagoInicialMovil: {
        cedula: '',
        telefono: '',
        referencia: '',
        banco_origen: '',
        banco_destino: null,
        numero_cuenta: '',
        cedula_titular: '',
        nombre_titular: '',
        banco_receptor_codigo: ''
      },
      
      pagoInicialTransferencia: {
        referencia: '',
        banco_origen: '',
        banco_destino: null,
        numero_cuenta: ''
      },
      
      puntoVenta: {
        referencia: ''
      },
      
      modoCliente: 'buscar',
      buscarCliente: '',
      clientesEncontrados: [],
      clienteSeleccionado: null,
      buscandoClientes: false,
      mostrarListaClientes: false,
      timeoutBusqueda: null,
      todosLosClientes: [],
      
      nuevoCliente: {
        tipoDocumento: '',
        documento: '',
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        direccion: '',
        estado: 'activo'
      },
      guardandoCliente: false,
      
      productosDisponibles: [],
      productosSeleccionados: [],
      buscarProducto: '',
      productosEncontrados: [],
      cargandoProductos: false,
      
      showModalProductos: false,
      
      vendedores: [],
      tasasVenta: [],
      tasaSeleccionada: null,
      metodosPago: [],
      
      bancosVenezuela: [],
      bancosEmpresa: [],
      
      subtotalOriginal: 0,
      totalConRecargo: 0,
      recargoTotal: 0,
      
      guardando: false,
      loading: false,
      timeoutBusquedaProducto: null,
      
      showConfirmModal: false,
      confirmModalTitle: '',
      confirmModalMessage: '',
      confirmModalIcon: 'mdi:check-circle',
      confirmModalIconClass: 'bg-green-100',
      confirmModalIconColor: 'text-green-600',
      confirmModalConfirmText: 'Aceptar',
      confirmModalCancelText: 'Cancelar',
      confirmModalType: 'success',
      confirmModalConfirmClass: 'bg-gradient-to-r from-green-600 to-emerald-600',
      confirmCallback: null,
      confirmCancelCallback: null,
      currentUser: null,
      vendedorActual: null,
      
      codigoEscaneadoCredito: '',
      productoEncontradoCredito: null,
      busquedaFallidaCredito: false,
      buscandoProductoCredito: false,
    };
  },
  computed: {
    cuentaInicialMovilSeleccionada() {
      return this.bancosEmpresa.find(c => c.idCuentaBancaria === this.pagoInicialMovil.banco_destino) || null;
    },
    cuentaInicialTransferenciaSeleccionada() {
      return this.bancosEmpresa.find(c => c.idCuentaBancaria === this.pagoInicialTransferencia.banco_destino) || null;
    },
    
    puedeCrearVentaCredito() {
      const baseValid = (
        this.clienteSeleccionado && 
        (this.clienteSeleccionado.idCliente || this.clienteSeleccionado.id) &&
        this.productosSeleccionados.length > 0 &&
        this.form.idVendedor &&
        this.form.idTasaVenta &&
        this.form.numero_factura &&
        this.tipoCredito
      );
      
      if (!baseValid) return false;
      
      if (this.tipoCredito === 'cacheas') {
        let inicialValida = true;
        if (this.cuotas.inicialPersonalizada < 0) inicialValida = false;
        if (this.cuotas.inicialPersonalizada > this.totalConRecargo) inicialValida = false;
        
        if (!inicialValida) return false;
        
        // Solo exigir método de pago si hay inicial > 0
        if (this.cuotas.inicial > 0) {
          if (!this.form.idMetodoPagoInicial) return false;
          if (this.esPagoMovilInicial) return this.validarPagoMovilInicial;
          if (this.esTransferenciaInicial) return this.validarTransferenciaInicial;
          if (this.esPuntoVentaInicial) return this.validarPuntoVentaInicial;
          if (this.esEfectivoInicial) return this.cuotas.fechaInicio !== '';
          return false;
        }
        
        // Si inicial = 0, solo requerir fecha de inicio
        return this.cuotas.fechaInicio !== '';
      }
      
      return true;
    },
    
    validarPagoMovilInicial() {
      return (this.pagoInicialMovil.banco_destino && 
              this.pagoInicialMovil.cedula && 
              this.pagoInicialMovil.telefono && 
              this.pagoInicialMovil.referencia && 
              this.pagoInicialMovil.banco_origen);
    },
    
    validarTransferenciaInicial() {
      return (this.pagoInicialTransferencia.referencia && 
              this.pagoInicialTransferencia.banco_origen && 
              this.pagoInicialTransferencia.banco_destino);
    },
    
    validarPuntoVentaInicial() {
      return Boolean(this.puntoVenta.referencia && /^[0-9]{4}$/.test(this.puntoVenta.referencia));
    },
    
    referenciaPuntoVenta() {
      return this.puntoVenta.referencia || null;
    },
    
    esPagoMovilInicial() {
      const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPagoInicial);
      return metodo?.tipo === 'pago_movil';
    },
    
    esTransferenciaInicial() {
      const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPagoInicial);
      return metodo?.tipo === 'transferencia';
    },
    
    esPuntoVentaInicial() {
      const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPagoInicial);
      return metodo?.tipo === 'punto_venta' || metodo?.nombre?.toLowerCase().includes('punto');
    },
    
    esEfectivoInicial() {
      const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPagoInicial);
      return metodo?.tipo === 'efectivo';
    },
    
    puedeGuardarCliente() {
      return this.nuevoCliente.tipoDocumento && this.nuevoCliente.documento && this.nuevoCliente.nombre;
    },
    
    productosParaMostrar() {
      if (this.buscarProducto?.length >= 2) return this.productosEncontrados;
      return this.productosDisponibles;
    }
  },
  watch: {
    'form.idTasaVenta'() {
      this.actualizarTasaSeleccionada();
    },
    'tasaSeleccionada': {
      handler() {
        this.calcularMontosCuotas();
      },
      deep: true
    },
    'form.descuento_usd'() {
      this.calcularTotales();
    },
    productosSeleccionados: {
      handler() {
        this.calcularTotales();
      },
      deep: true
    },
    'tipoCredito': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && this.productosSeleccionados.length > 0) {
          this.productosSeleccionados.forEach(producto => {
            if (newVal === 'cacheas') {
              producto.subtotal_con_recargo = producto.cantidad * (producto.precio_unitario_usd * 1.17);
            } else {
              producto.subtotal_con_recargo = producto.subtotal;
            }
          });
          this.calcularTotales();
        }
      }
    }
  },
  async mounted() {
    await this.cargarDatosIniciales();
    await this.generarNumeroOrden();
    await this.cargarTodosLosClientes();
    const hoy = new Date();
    this.cuotas.fechaInicio = hoy.toISOString().split('T')[0];
    this.calcularFechasCuotas();
    this.cuotas.inicialPersonalizada = 0;
    this.cuotas.inicial = 0;
    this.$nextTick(() => {
      if (this.$refs.lectorCreditoInput) {
        this.$refs.lectorCreditoInput.focus();
      }
    });
  },
  methods: {
    extraerCodigoBanco(valor) {
      if (!valor) return null;
      if (typeof valor === 'object') return valor.pmBancoCodigo || valor.bancoCodigo || null;
      const m = String(valor).match(/(\d{4})/);
      return m ? m[1] : null;
    },

    getImageUrl(imagen) {
      return obtenerUrlImagen(imagen);
    },
    handleImageError(event) { 
      event.target.style.display = 'none'; 
    },
    
    async buscarProductoPorCodigoCredito() {
      const codigo = this.codigoEscaneadoCredito.trim();
      if (!codigo) {
        this.toast.warning('Ingresa o escanea un código');
        return;
      }
      if (!this.clienteSeleccionado) {
        this.toast.warning('Primero selecciona un cliente');
        return;
      }

      let producto = this.productosDisponibles.find(p => {
        const codigoEsc = codigo.toLowerCase();
        return p.codigo?.toLowerCase() === codigoEsc ||
               p.codigoBarras?.toLowerCase() === codigoEsc;
      });

      if (!producto) {
        this.buscandoProductoCredito = true;
        try {
          let resultado = await obtenerProductoPorCodigo(codigo);
          if (!resultado.success || !resultado.data) {
            resultado = await obtenerProductoPorCodigoBarras(codigo);
          }
          if (resultado.success && resultado.data) {
            producto = resultado.data;
            const existe = this.productosDisponibles.some(p => p.idProducto === producto.idProducto);
            if (!existe) {
              this.productosDisponibles.push({
                ...producto,
                precio_unitario_usd: producto.precio_venta_usd || 0,
                costo_unitario_usd: producto.costo_unitario_usd || 0
              });
            }
          }
        } catch (error) {
          console.error('❌ Error:', error);
          this.toast.error('Error al buscar');
          this.buscandoProductoCredito = false;
          return;
        }
        this.buscandoProductoCredito = false;
      }

      if (producto) {
        this.productoEncontradoCredito = producto;
        this.busquedaFallidaCredito = false;
        this.codigoEscaneadoCredito = '';
        this.$refs.lectorCreditoInput?.focus();
        this.toast.success(`Encontrado: ${producto.nombre}`);
      } else {
        this.productoEncontradoCredito = null;
        this.busquedaFallidaCredito = true;
        this.toast.error('Producto no encontrado');
      }
    },
    
    agregarProductoDesdeLectorCredito(producto) {
      if (this.productoYaAgregado(producto)) {
        this.toast.info('Ya está en la lista');
        return;
      }
      
      const precioOriginal = producto.precio_venta_usd || 0;
      const subtotalOriginal = precioOriginal;
      const subtotalConRecargo = this.tipoCredito === 'cacheas' ? precioOriginal * 1.17 : precioOriginal;
      
      this.productosSeleccionados.push({
        idProducto: producto.idProducto,
        nombre: producto.nombre,
        codigo: producto.codigo,
        cantidad: 1,
        precio_original_usd: precioOriginal,
        precio_unitario_usd: precioOriginal,
        precio_final_cacheas: this.redondear(precioOriginal * 1.17),
        stock: producto.stock,
        subtotal: subtotalOriginal,
        subtotal_con_recargo: subtotalConRecargo,
        costo_unitario_usd: producto.costo_unitario_usd || 0,
        garantia_meses: producto.garantia_meses || producto.garantiaMeses || 0,
        imagen: producto.imagen
      });
      
      this.calcularTotales();
      this.productoEncontradoCredito = null;
      this.codigoEscaneadoCredito = '';
      this.$refs.lectorCreditoInput?.focus();
      this.toast.success(`${producto.nombre} agregado`);
    },
    
    async cargarTodosLosClientes() {
      try {
        const response = await obtenerClientes();
        if (response.success) {
          this.todosLosClientes = response.data || [];
        }
      } catch (error) {
        console.error('Error cargando clientes:', error);
      }
    },
    
    buscarClientesLocal() {
      if (!this.buscarCliente || this.buscarCliente.trim() === '') {
        this.clientesEncontrados = [];
        this.mostrarListaClientes = false;
        return;
      }
      
      this.buscandoClientes = true;
      const termino = this.buscarCliente.toLowerCase().trim();
      
      setTimeout(() => {
        this.clientesEncontrados = this.todosLosClientes.filter(cliente => {
          const nombreCompleto = `${cliente.nombre || ''} ${cliente.apellido || ''}`.toLowerCase();
          const documento = (cliente.documento || '').toLowerCase();
          const telefono = (cliente.telefono || '').toLowerCase();
          const email = (cliente.email || '').toLowerCase();
          
          return nombreCompleto.includes(termino) || 
                 documento.includes(termino) || 
                 telefono.includes(termino) || 
                 email.includes(termino);
        }).slice(0, 10);
        
        this.buscandoClientes = false;
        
        if (this.clientesEncontrados.length === 0 && termino.length >= 2) {
          this.mostrarListaClientes = true;
        }
      }, 300);
    },
    
    debounceBuscarClientes() {
      this.mostrarListaClientes = true;
      if (this.timeoutBusqueda) clearTimeout(this.timeoutBusqueda);
      this.timeoutBusqueda = setTimeout(() => {
        this.buscarClientesLocal();
      }, 300);
    },
    
    async guardarNuevoCliente() {
      if (!this.puedeGuardarCliente) {
        this.mostrarToastError('Complete los campos requeridos');
        return;
      }
      
      try {
        this.guardandoCliente = true;
        
        const datosClienteOriginal = { ...this.nuevoCliente };
        
        if (this.nuevoCliente.tipoDocumento && this.nuevoCliente.documento) {
          this.nuevoCliente.documento = formatearDocumento(this.nuevoCliente.tipoDocumento, this.nuevoCliente.documento);
        }
        if (this.nuevoCliente.telefono) {
          this.nuevoCliente.telefono = formatearTelefonoVenezolano(this.nuevoCliente.telefono);
        }
        
        const response = await crearCliente(this.nuevoCliente);
        
        if (response.success) {
          const clienteCreado = response.data;
          
          const clienteFormateado = {
            idCliente: clienteCreado.idCliente || clienteCreado.id,
            nombre: clienteCreado.nombre || datosClienteOriginal.nombre,
            apellido: clienteCreado.apellido || datosClienteOriginal.apellido || '',
            tipoDocumento: clienteCreado.tipoDocumento || datosClienteOriginal.tipoDocumento,
            documento: clienteCreado.documento || datosClienteOriginal.documento,
            telefono: clienteCreado.telefono || datosClienteOriginal.telefono || '',
            email: clienteCreado.email || datosClienteOriginal.email || '',
            direccion: clienteCreado.direccion || datosClienteOriginal.direccion || ''
          };
          
          this.todosLosClientes.push(clienteFormateado);
          this.seleccionarCliente(clienteFormateado);
          
          this.nuevoCliente = {
            tipoDocumento: '',
            documento: '',
            nombre: '',
            apellido: '',
            telefono: '',
            email: '',
            direccion: '',
            estado: 'activo'
          };
          
          this.modoCliente = 'buscar';
          this.mostrarToastExito('Cliente creado y seleccionado correctamente');
        } else {
          throw new Error(response.error || 'Error al crear el cliente');
        }
      } catch (error) {
        console.error('Error creando cliente:', error);
        this.mostrarToastError('No se pudo crear el cliente: ' + error.message);
      } finally {
        this.guardandoCliente = false;
      }
    },
    
    mostrarClientesSiHay() {
      if (this.clientesEncontrados.length > 0) {
        this.mostrarListaClientes = true;
      } else if (this.buscarCliente && this.buscarCliente.length >= 2 && !this.buscandoClientes) {
        this.mostrarListaClientes = true;
      }
    },
    
    seleccionarCliente(cliente) {
      this.clienteSeleccionado = { ...cliente };
      this.form.idCliente = cliente.idCliente || cliente.id || cliente.id_cliente;
      this.buscarCliente = '';
      this.clientesEncontrados = [];
      this.mostrarListaClientes = false;
      this.mostrarToastExito(`Cliente ${cliente.nombre} seleccionado`);
    },
    
    deseleccionarCliente() {
      this.clienteSeleccionado = null;
      this.form.idCliente = null;
      this.productosSeleccionados = [];
      this.calcularTotales();
    },
    
    redondear(numero) {
      if (isNaN(numero)) return 0;
      return Math.round((numero + Number.EPSILON) * 100) / 100;
    },
    
    redondearYFormatear(numero) {
      return this.redondear(numero).toFixed(2);
    },
    
    formatearMontoBs(numero) {
      const n = this.redondear(numero);
      return n.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    
    mostrarToastExito(m) { this.toast.success(m, { timeout: 3000 }); },
    mostrarToastError(m) { this.toast.error(m, { timeout: 5000 }); },
    mostrarToastInfo(m) { this.toast.info(m, { timeout: 3000 }); },
    
    seleccionarTipoCredito(tipo) {
      this.tipoCredito = tipo;
      this.calcularTotales();
    },
    
    async generarNumeroOrden() {
      try {
        const result = await obtenerSiguienteNumeroFactura();
        this.form.numero_factura = result.data;
      } catch (error) {
        console.error('Error generando número de factura:', error);
        this.form.numero_factura = 'FR-6000';
      }
    },
    
    formatearTipoDocumento(tipo) {
      const tipos = { 
        'cedula': 'Cédula', 
        'rif': 'RIF', 
        'pasaporte': 'Pasaporte', 
        'identificacion_extranjera': 'Identificación Extranjera',
        'CEDULA': 'Cédula',
        'RIF': 'RIF',
        'PASAPORTE': 'Pasaporte'
      };
      return tipos[tipo] || tipos[tipo?.toLowerCase()] || 'Sin documento';
    },
    
    getPlaceholderDocumento(tipo) {
      const placeholders = { 'cedula': 'V-31.757.818', 'rif': 'J-12345678-9', 'pasaporte': 'ABC123456', 'identificacion_extranjera': 'Número de identificación' };
      return placeholders[tipo] || 'Número de documento';
    },
    
    formatearDocumentoInput() {
      if (this.nuevoCliente.tipoDocumento && this.nuevoCliente.documento) {
        this.nuevoCliente.documento = formatearDocumento(this.nuevoCliente.tipoDocumento, this.nuevoCliente.documento);
      }
    },
    
    formatearTelefonoInput() {
      if (this.nuevoCliente.telefono) {
        this.nuevoCliente.telefono = formatearTelefonoVenezolano(this.nuevoCliente.telefono);
      }
    },
    
    formatearFecha(fechaISO) {
      if (!fechaISO) return 'N/A';
      const fecha = new Date(fechaISO);
      return fecha.toLocaleDateString('es-ES');
    },
    
    calcularFechasCuotas() {
      if (!this.cuotas.fechaInicio) return;
      const fechaInicio = new Date(this.cuotas.fechaInicio);
      for (let i = 0; i < 3; i++) {
        const fechaCuota = new Date(fechaInicio);
        fechaCuota.setDate(fechaCuota.getDate() + (7 * (i + 1)));
        this.cuotas.lista[i].fechaPago = fechaCuota.toISOString().split('T')[0];
      }
    },
    
    actualizarInicial() {
      let monto = this.redondear(this.cuotas.inicialPersonalizada);
      
      if (isNaN(monto) || monto < 0) {
        monto = 0;
      }
      if (monto > this.totalConRecargo) {
        monto = this.totalConRecargo;
        this.mostrarToastInfo(`El monto no puede ser mayor al total de $${this.redondearYFormatear(this.totalConRecargo)}`);
      }
      
      this.cuotas.inicialPersonalizada = monto;
      this.cuotas.inicial = monto;
      this.calcularMontosCuotas();
    },
    
    calcularTotales() {
      this.subtotalOriginal = this.redondear(this.productosSeleccionados.reduce((sum, p) => sum + (p.subtotal || 0), 0));
      
      const descuento = this.redondear(this.form.descuento_usd || 0);
      const subtotalConDescuento = this.redondear(Math.max(0, this.subtotalOriginal - descuento));
      
      if (this.tipoCredito === 'cacheas') {
        this.totalConRecargo = this.redondear(this.productosSeleccionados.reduce((sum, p) => {
          const precioConRecargo = (p.precio_unitario_usd * 1.17) * p.cantidad;
          return sum + precioConRecargo;
        }, 0));
        
        this.recargoTotal = this.redondear(this.totalConRecargo - subtotalConDescuento);
      } else {
        this.totalConRecargo = subtotalConDescuento;
        this.recargoTotal = 0;
      }
      
      if (this.cuotas.inicialPersonalizada > this.totalConRecargo) {
        this.cuotas.inicialPersonalizada = this.totalConRecargo;
        this.cuotas.inicial = this.totalConRecargo;
      }
      
      this.calcularMontosCuotas();
    },
    
    actualizarRecargoDesdeTotal() {
      if (this.totalConRecargo < 0) this.totalConRecargo = 0;
      const descuento = this.redondear(this.form.descuento_usd || 0);
      const subtotalConDescuento = this.redondear(Math.max(0, this.subtotalOriginal - descuento));
      
      this.recargoTotal = this.redondear(this.totalConRecargo - subtotalConDescuento);
      
      if (this.cuotas.inicialPersonalizada > this.totalConRecargo) {
        this.cuotas.inicialPersonalizada = this.totalConRecargo;
        this.cuotas.inicial = this.totalConRecargo;
      }
      
      this.calcularMontosCuotas();
    },
    
    actualizarSubtotalProducto(producto) {
      if (producto.cantidad < 1) producto.cantidad = 1;
      
      producto.subtotal = this.redondear(producto.cantidad * producto.precio_unitario_usd);
      
      if (this.tipoCredito === 'cacheas') {
        producto.precio_final_cacheas = this.redondear(producto.precio_unitario_usd * 1.17);
        producto.subtotal_con_recargo = this.redondear(producto.cantidad * producto.precio_final_cacheas);
      } else {
        producto.subtotal_con_recargo = producto.subtotal;
      }
      
      this.calcularTotales();
    },
    
    calcularMontosCuotas() {
      if (this.tipoCredito !== 'cacheas') return;
      
      const montoTotal = this.redondear(this.totalConRecargo);
      const montoInicial = this.redondear(this.cuotas.inicial);
      const saldoRestante = this.redondear(Math.max(0, montoTotal - montoInicial));
      const montoPorCuota = this.redondear(saldoRestante / 3);
      const tasa = this.tasaSeleccionada?.precio_usd_bs || 0;
      
      for (let i = 0; i < 3; i++) {
        this.cuotas.lista[i].montoUsd = montoPorCuota;
        this.cuotas.lista[i].montoBs = this.redondear(montoPorCuota * tasa);
      }
    },
    
    async cargarDatosIniciales() {
      try {
        this.loading = true;

        this.currentUser = getCurrentUser();
        if (this.currentUser) {
          this.form.idUsuario = this.currentUser.idUsuario || this.currentUser.id;
          
          const vendedorRes = await obtenerVendedorPorIdUsuario(this.form.idUsuario);
          if (vendedorRes.success && vendedorRes.data) {
            this.vendedorActual = vendedorRes.data;
            this.form.idVendedor = this.vendedorActual.idVendedor;
          } else {
            console.warn('No se encontró un vendedor para el usuario actual');
            this.vendedorActual = {
              nombre: this.currentUser.nombre || 'Admin',
              apellido: this.currentUser.apellido || ''
            };
          }
        }

        const vendedoresRes = await obtenerVendedores();
        if (vendedoresRes.success) this.vendedores = vendedoresRes.data || [];
        
        const productosRes = await obtenerProductos();
        if (productosRes.success) {
          this.productosDisponibles = productosRes.data || [];
        }
        
        const tasasRes = await obtenerTasasVenta('activas');
        if (tasasRes?.success && tasasRes.data?.length) {
          this.tasasVenta = tasasRes.data;
          this.form.idTasaVenta = this.tasasVenta[0].idTasaVenta;
          this.actualizarTasaSeleccionada();
        }
        
        const metodosRes = await obtenerMetodosPago();
        if (metodosRes.success) this.metodosPago = metodosRes.data || [];

        const bancosRes = await obtenerBancosPagoMovil();
        if (bancosRes.success) {
          this.bancosVenezuela = (bancosRes.data || []).map(b => `${b.codigo} - ${b.nombre}`);
        }
        const cuentasRes = await obtenerCuentasPropias();
        if (cuentasRes.success) {
          this.bancosEmpresa = cuentasRes.data || [];
        }
      } catch (error) {
        console.error('Error:', error);
        this.mostrarToastError('Error al cargar datos');
      } finally {
        this.loading = false;
      }
    },
    
    actualizarTasaSeleccionada() {
      if (this.form.idTasaVenta) {
        this.tasaSeleccionada = this.tasasVenta.find(t => t.idTasaVenta == this.form.idTasaVenta);
        if (this.tasaSeleccionada) {
          this.form.tasa_bs_usd = this.tasaSeleccionada.precio_usd_bs;
          this.calcularMontosCuotas();
        }
      }
    },
    
    mostrarModalProductos() {
      if (!this.clienteSeleccionado) {
        this.mostrarToastInfo('Selecciona un cliente primero');
        return;
      }
      this.showModalProductos = true;
    },
    
    cerrarModalProductos() {
      this.showModalProductos = false;
      this.buscarProducto = '';
    },
    
    debounceBuscarProductos() {
      if (this.timeoutBusquedaProducto) clearTimeout(this.timeoutBusquedaProducto);
      this.timeoutBusquedaProducto = setTimeout(() => this.buscarProductosLocal(), 500);
    },
    
    buscarProductosLocal() {
      if (!this.buscarProducto?.trim()) {
        this.productosEncontrados = [];
        return;
      }
      const termino = this.buscarProducto.toLowerCase();
      this.productosEncontrados = this.productosDisponibles.filter(p => 
        p.nombre.toLowerCase().includes(termino) || p.codigo.toLowerCase().includes(termino)
      );
    },
    
    productoYaAgregado(producto) {
      return this.productosSeleccionados.some(p => p.idProducto === producto.idProducto);
    },
    
    agregarProducto(producto) {
      if (this.productoYaAgregado(producto)) return;
      
      const precioOriginal = producto.precio_venta_usd || 0;
      const subtotalOriginal = precioOriginal;
      const subtotalConRecargo = this.tipoCredito === 'cacheas' ? precioOriginal * 1.17 : precioOriginal;
      
      this.productosSeleccionados.push({
        idProducto: producto.idProducto,
        nombre: producto.nombre,
        codigo: producto.codigo,
        cantidad: 1,
        precio_original_usd: precioOriginal,
        precio_unitario_usd: precioOriginal,
        precio_final_cacheas: this.redondear(precioOriginal * 1.17),
        stock: producto.stock,
        subtotal: subtotalOriginal,
        subtotal_con_recargo: subtotalConRecargo,
        costo_unitario_usd: producto.costo_unitario_usd || 0,
        garantia_meses: producto.garantia_meses || producto.garantiaMeses || 0,
        imagen: producto.imagen
      });
      
      this.calcularTotales();
      this.mostrarToastExito(`${producto.nombre} agregado`);
    },
    
    removerProducto(index) {
      this.productosSeleccionados.splice(index, 1);
      this.calcularTotales();
    },
    
    onMetodoPagoInicialChange() {
      this.pagoInicialMovil = { cedula: '', telefono: '', referencia: '', banco_origen: '', banco_destino: null, numero_cuenta: '', cedula_titular: '', nombre_titular: '', banco_receptor_codigo: '' };
      this.pagoInicialTransferencia = { referencia: '', banco_origen: '', banco_destino: null, numero_cuenta: '' };
      this.puntoVenta = { referencia: '' };
    },
    
    validarPuntoVenta() {
      if (this.puntoVenta.referencia) {
        this.puntoVenta.referencia = this.puntoVenta.referencia.replace(/[^0-9]/g, '').slice(0, 4);
      }
    },
    
    autocompletarDatosBancoDestinoInicial() {
      const cuenta = this.cuentaInicialMovilSeleccionada;
      if (cuenta) {
        this.pagoInicialMovil.numero_cuenta = cuenta.numeroCuenta || '';
        this.pagoInicialMovil.cedula_titular = cuenta.titularDocumento || '';
        this.pagoInicialMovil.nombre_titular = cuenta.titularNombreCompleto || '';
        this.pagoInicialMovil.banco_receptor_codigo = cuenta.pmBancoCodigo || cuenta.bancoCodigo || '';
      } else {
        this.pagoInicialMovil.numero_cuenta = '';
        this.pagoInicialMovil.cedula_titular = '';
        this.pagoInicialMovil.nombre_titular = '';
        this.pagoInicialMovil.banco_receptor_codigo = '';
      }
    },
    
    autocompletarDatosTransferenciaInicial() {
      const cuenta = this.cuentaInicialTransferenciaSeleccionada;
      if (cuenta) {
        this.pagoInicialTransferencia.numero_cuenta = cuenta.numeroCuenta || '';
      } else {
        this.pagoInicialTransferencia.numero_cuenta = '';
      }
    },
    
    obtenerDatosPagoInicial() {
      if (this.esPagoMovilInicial) {
        return {
          tipo: 'pago_movil',
          banco_destino: this.pagoInicialMovil.banco_destino,
          cedula: this.pagoInicialMovil.cedula,
          telefono: this.pagoInicialMovil.telefono,
          banco_origen: this.pagoInicialMovil.banco_origen,
          referencia: this.pagoInicialMovil.referencia,
          numero_cuenta: this.pagoInicialMovil.numero_cuenta,
          cedula_titular: this.pagoInicialMovil.cedula_titular,
          nombre_titular: this.pagoInicialMovil.nombre_titular
        };
      } else if (this.esTransferenciaInicial) {
        return {
          tipo: 'transferencia',
          referencia: this.pagoInicialTransferencia.referencia,
          banco_origen: this.pagoInicialTransferencia.banco_origen,
          banco_destino: this.pagoInicialTransferencia.banco_destino,
          numero_cuenta: this.pagoInicialTransferencia.numero_cuenta
        };
      } else if (this.esPuntoVentaInicial) {
        return {
          tipo: 'punto_venta',
          referencia: this.referenciaPuntoVenta
        };
      }
      return { tipo: 'efectivo' };
    },
    
    prepararObservaciones() {
      const lineas = [`Tipo: CRÉDITO - ${this.tipoCredito === 'cacheas' ? 'CACHÉAS (17% recargo por producto)' : 'EMPRESA'}`];
      lineas.push(`Factura: ${this.form.numero_factura}`);
      lineas.push(`Subtotal original: $${this.redondearYFormatear(this.subtotalOriginal)}`);
      if (this.form.descuento_usd) lineas.push(`Descuento: -$${this.redondearYFormatear(this.form.descuento_usd)}`);
      if (this.tipoCredito === 'cacheas') {
        lineas.push(`Recargo 17%: $${this.redondearYFormatear(this.recargoTotal)}`);
        lineas.push(`Total con recargo: $${this.redondearYFormatear(this.totalConRecargo)}`);
        lineas.push(`Inicial: $${this.redondearYFormatear(this.cuotas.inicial)}`);
        lineas.push(`Saldo a financiar: $${this.redondearYFormatear(this.totalConRecargo - this.cuotas.inicial)} en 3 cuotas`);
        if (this.cuotas.inicial > 0) {
          const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPagoInicial);
          lineas.push(`Método de pago inicial: ${metodo?.nombre || 'No especificado'}`);
          if (this.esPagoMovilInicial) {
            lineas.push(`Pago Móvil - Cuenta: ${this.cuentaInicialMovilSeleccionada?.numeroCuenta}, Ref: ${this.pagoInicialMovil.referencia}`);
          }
          if (this.esTransferenciaInicial) {
            lineas.push(`Transferencia - Cuenta: ${this.cuentaInicialTransferenciaSeleccionada?.numeroCuenta}, Ref: ${this.pagoInicialTransferencia.referencia}`);
          }
          if (this.esPuntoVentaInicial) {
            lineas.push(`Punto de Venta - Ref: ${this.referenciaPuntoVenta}`);
          }
        }
      }
      return lineas.join('\n');
    },
    
    async crearVentaCredito() {
      if (!this.puedeCrearVentaCredito) {
        this.mostrarToastError('Complete todos los campos');
        return;
      }
      
      try {
        this.guardando = true;
        
        const idFuenteTasaVenta = this.tasaSeleccionada?.idFuenteTasa || 2;
        
        const costoTotalUsd = this.productosSeleccionados.reduce((sum, p) => sum + ((p.costo_unitario_usd || 0) * p.cantidad), 0);
        const gananciaNetaUsd = this.totalConRecargo - costoTotalUsd;
        const margenGanancia = costoTotalUsd > 0 ? (gananciaNetaUsd / costoTotalUsd) * 100 : 0;

        const ventaData = {
          numeroFactura: this.form.numero_factura,
          fechaVenta: new Date().toISOString(),
          tipoVenta: 'credito',
          subtipoCredito: this.tipoCredito,
          subtotalOriginalUsd: parseFloat(this.subtotalOriginal) || 0,
          descuentoUsd: parseFloat(this.form.descuento_usd) || 0,
          totalConRecargoUsd: parseFloat(this.totalConRecargo) || 0,
          totalUsd: parseFloat(this.totalConRecargo) || 0,
          subtotalUsd: parseFloat(this.subtotalOriginal) || 0,
          costoTotalUsd: parseFloat(costoTotalUsd) || 0,
          gananciaNetaUsd: parseFloat(gananciaNetaUsd) || 0,
          margenGananciaPorcentaje: parseFloat(margenGanancia) || 0,
          recargoPorcentaje: this.tipoCredito === 'cacheas' ? 17 : 0,
          recargoMontoUsd: parseFloat(this.recargoTotal) || 0,
          tasaBsUsd: parseFloat(this.tasaSeleccionada?.precio_usd_bs || 0),
          idTasaVenta: parseInt(this.form.idTasaVenta),
          idFuenteTasaVenta: parseInt(idFuenteTasaVenta),
          idVendedor: parseInt(this.form.idVendedor),
          idCliente: (this.form.idCliente || (this.clienteSeleccionado ? (this.clienteSeleccionado.idCliente || this.clienteSeleccionado.id) : null)) ? parseInt(this.form.idCliente || (this.clienteSeleccionado ? (this.clienteSeleccionado.idCliente || this.clienteSeleccionado.id) : null)) : null,
          idUsuario: 1, 
          estado: this.tipoCredito === 'cacheas' ? (this.cuotas.inicial > 0 ? 'parcial' : 'pendiente') : 'pendiente',
          observaciones: this.prepararObservaciones(),
          detalles: this.productosSeleccionados.map(p => {
            const subtotalProd = p.subtotal || (p.cantidad * p.precio_unitario_usd);
            const costoTotalProd = (p.costo_unitario_usd || 0) * p.cantidad;
            const gananciaProd = subtotalProd - costoTotalProd;
            const margenProd = costoTotalProd > 0 ? (gananciaProd / costoTotalProd) * 100 : 0;

            return {
              idProducto: parseInt(p.idProducto),
              cantidad: parseInt(p.cantidad),
              precioUnitarioUsd: parseFloat(p.precio_unitario_usd),
              subtotalUsd: parseFloat(subtotalProd),
              costoUnitarioUsd: parseFloat(p.costo_unitario_usd || 0),
              costoTotalUsd: parseFloat(costoTotalProd),
              gananciaUnitarioUsd: parseFloat(p.precio_unitario_usd - (p.costo_unitario_usd || 0)),
              gananciaTotalUsd: parseFloat(gananciaProd),
              margenGananciaPorcentaje: parseFloat(margenProd),
              garantiaMeses: p.garantia_meses || 0,
              garantiaDias: 0,
              tieneGarantia: (p.garantia_meses || 0) > 0
            };
          })
        };
        
        if (this.tipoCredito === 'cacheas') {
          ventaData.cuotas = {
            inicial: {
              montoUsd: this.cuotas.inicial,
              metodoPago: this.form.idMetodoPagoInicial,
              datosPago: this.obtenerDatosPagoInicial()
            },
            fechaInicio: this.cuotas.fechaInicio,
            lista: this.cuotas.lista
          };
        }
        
        if (this.tipoCredito === 'empresa') {
          ventaData.creditoEmpresa = {
            fechaPagoAcordada: this.creditoEmpresa.fechaPagoAcordada,
            observaciones: this.creditoEmpresa.observaciones
          };
        }
        
        const response = await apiCrearVentaCredito(ventaData);
        
        if (response.success) {
          if (this.cuotas.inicial > 0) {
            try {
              const ventaCreada = response.data;
              let referencia = '';
              
              if (this.esPuntoVentaInicial) {
                referencia = this.referenciaPuntoVenta || `PV-${Date.now()}`;
              } else if (this.esPagoMovilInicial) {
                referencia = this.pagoInicialMovil.referencia || `PM-${Date.now()}`;
              } else if (this.esTransferenciaInicial) {
                referencia = this.pagoInicialTransferencia.referencia || `TR-${Date.now()}`;
              } else {
                referencia = `EFE-${Date.now()}`;
              }

              const pagoPayload = {
                idVenta: ventaCreada.idVenta,
                montoUsd: this.cuotas.inicial,
                montoBs: this.cuotas.inicial * (this.tasaSeleccionada?.precio_usd_bs || 0),
                fechaPago: new Date().toISOString(),
                tipoPago: this.esPuntoVentaInicial ? 'punto_venta' : (this.esPagoMovilInicial ? 'pago_movil' : (this.esTransferenciaInicial ? 'transferencia' : 'efectivo')),
                numeroRecibo: referencia,
                observaciones: `Pago inicial de crédito - Factura: ${this.form.numero_factura}`
              };

              await registrarPagoVenta(pagoPayload);

              const cuentaDestinoInicial = this.cuentaInicialMovilSeleccionada || this.cuentaInicialTransferenciaSeleccionada;
              if (cuentaDestinoInicial) {
                try {
                  const metodoPagoTipo = this.esPagoMovilInicial
                    ? 'pago_movil'
                    : (this.esTransferenciaInicial ? 'transferencia' : (this.esPuntoVentaInicial ? 'punto_venta' : 'efectivo'));

                  await crearPagoCuenta({
                    tipoDocumentoPago: 'venta',
                    idDocumentoPago: ventaCreada.idVenta,
                    idCuentaBancaria: cuentaDestinoInicial.idCuentaBancaria,

                    montoUsd: this.cuotas.inicial,
                    montoBs: this.cuotas.inicial * (this.tasaSeleccionada?.precio_usd_bs || 0),
                    tasaBsUsd: this.tasaSeleccionada?.precio_usd_bs || 0,

                    metodoPago: metodoPagoTipo,
                    referencia: referencia,
                    fechaPago: new Date().toISOString(),

                    pmBancoEmisorCodigo:   metodoPagoTipo === 'pago_movil' ? this.extraerCodigoBanco(this.pagoInicialMovil.banco_origen) : null,
                    pmBancoReceptorCodigo: metodoPagoTipo === 'pago_movil' ? (cuentaDestinoInicial.pmBancoCodigo || cuentaDestinoInicial.bancoCodigo || null) : null,
                    pmTelefonoEmisor:      metodoPagoTipo === 'pago_movil' ? this.pagoInicialMovil.telefono : null,
                    pmDocumentoEmisor:     metodoPagoTipo === 'pago_movil' ? this.pagoInicialMovil.cedula : null,
                    pmCodigoOperacion:     metodoPagoTipo === 'pago_movil' ? this.pagoInicialMovil.referencia : null,

                    observaciones: `Pago inicial de crédito Cachéas - Factura ${this.form.numero_factura}`
                  });
                } catch (errCuenta) {
                  console.error('⚠️ No se pudo asociar el pago inicial a la cuenta:', errCuenta);
                  this.mostrarToastInfo('El pago se registró, pero no se pudo asociar a la cuenta bancaria');
                }
              }
            } catch (pagoError) {
              console.error('❌ Error registrando pago inicial:', pagoError);
              this.mostrarToastError('La venta se creó pero no se pudo registrar el pago inicial.');
            }
          }

          this.mostrarConfirmacion({
            title: '¡Venta creada!',
            message: `Factura: ${this.form.numero_factura}<br>Total: $${this.redondearYFormatear(this.totalConRecargo)}<br>Inicial/Abono: $${this.redondearYFormatear(this.cuotas.inicial)}`,
            type: 'success',
            confirmText: 'Ver ventas',
            onConfirm: () => this.$router.push('/ventas')
          });

          const productosFactura = this.productosSeleccionados.map(p => ({
            nombre: p.nombre,
            codigo: p.codigo,
            cantidad: p.cantidad,
            precio: p.precio_unitario_usd,
            garantiaMeses: p.garantia_meses || p.garantiaMeses || 0
          }));

          const ventaFactura = {
            numeroFactura: this.form.numero_factura,
            subtotal: this.subtotalOriginal,
            descuentoUSD: this.form.descuento_usd || 0,
            total: this.totalConRecargo,
            metodoPago: this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPagoInicial)?.nombre || (this.tipoCredito === 'cacheas' ? 'CACHÉAS' : 'FIADO'),
            tipoVenta: 'CREDITO',
            montoInicial: this.cuotas.inicial || 0,
            numeroCuotas: this.tipoCredito === 'cacheas' ? 3 : 0
          };

          const vendedor = this.vendedores.find(v => v.idVendedor == this.form.idVendedor);

          setTimeout(() => {
            imprimirFactura(
              ventaFactura, 
              this.clienteSeleccionado, 
              vendedor || { nombre: 'VENDEDOR' }, 
              this.tasaSeleccionada, 
              productosFactura
            );
          }, 500);

        } else {
          throw new Error(response.error || 'Error al crear la venta');
        }
      } catch (error) {
        console.error('Error:', error);
        this.mostrarToastError(error.message || 'No se pudo crear la venta');
      } finally {
        this.guardando = false;
      }
    },
    
    volverAListado() {
      if (this.productosSeleccionados.length) {
        this.mostrarConfirmacion({
          title: '¿Salir sin guardar?',
          message: 'Hay información sin guardar',
          type: 'warning',
          confirmText: 'Sí, salir',
          onConfirm: () => this.$router.push('/ventas')
        });
      } else {
        this.$router.push('/ventas');
      }
    },
    
    mostrarConfirmacion(options) {
      this.confirmModalTitle = options.title;
      this.confirmModalMessage = options.message;
      this.confirmModalType = options.type || 'confirm';
      this.confirmModalConfirmText = options.confirmText || 'Aceptar';
      this.confirmModalCancelText = options.cancelText || 'Cancelar';
      this.confirmCallback = options.onConfirm;
      this.confirmCancelCallback = options.onCancel;
      
      if (options.type === 'danger') {
        this.confirmModalConfirmClass = 'bg-gradient-to-r from-red-600 to-rose-600';
        this.confirmModalIconClass = 'bg-red-100';
        this.confirmModalIconColor = 'text-red-600';
        this.confirmModalIcon = 'mdi:alert';
      } else if (options.type === 'success') {
        this.confirmModalConfirmClass = 'bg-gradient-to-r from-green-600 to-emerald-600';
        this.confirmModalIconClass = 'bg-green-100';
        this.confirmModalIconColor = 'text-green-600';
        this.confirmModalIcon = 'mdi:check-circle';
      } else {
        this.confirmModalConfirmClass = 'bg-gradient-to-r from-yellow-600 to-amber-600';
        this.confirmModalIconClass = 'bg-yellow-100';
        this.confirmModalIconColor = 'text-yellow-600';
        this.confirmModalIcon = 'mdi:alert';
      }
      
      this.showConfirmModal = true;
    },
    
    cancelarConfirmacion() {
      this.showConfirmModal = false;
      if (this.confirmCancelCallback) this.confirmCancelCallback();
    },
    
    aceptarConfirmacion() {
      this.showConfirmModal = false;
      if (this.confirmCallback) this.confirmCallback();
    }
  }
};
</script>

<style scoped>
.animate-fadeIn {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.dark ::-webkit-scrollbar-track {
  background: #374151;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.dark ::-webkit-scrollbar-thumb {
  background: #4b5563;
}

/* Forzar opciones legibles en modo oscuro */
.dark select option {
  background-color: #1f2937;
  color: #ffffff;
}
</style>